import { useContext } from "react";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { Button } from "@ui/components/forms/button/Button";
import { Controller } from "./controller";
import { ECCOIcon } from "@ui/components/media-and-icons/ecco-icon/ECCOIcon";

export const Capture = () => {
    const { get: getMicrocopy } = useMicrocopy();
    const { setClientLocation, setFilterDistance, filterDistance } = useContext(Controller);

    const handleCapture = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position: GeolocationPosition) => {
                    setClientLocation({
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    });
                },
                () => {
                    // eslint-disable-next-line
                    console.error("The Geolocation service failed.");
                }
            );
            if (filterDistance) setFilterDistance(null);
        } else {
            // eslint-disable-next-line
            console.error("Error: Your browser doesn't support geolocation.");
        }
    };

    return (
        <Button
            h="initial"
            variant="link"
            textDecoration="none"
            fontWeight="bold"
            justifyContent="flex-start"
            pr={{ base: 0, xl: 6 }}
            onClick={handleCapture}
            leftIcon={<ECCOIcon name="store-locator" />}
        >
            <span>{getMicrocopy("page", "storeLocator.captureLocation")}</span>
        </Button>
    );
};
